import useGetTotalStatistics from './useGetTotalStatistics'

export default useGetTotalStatistics
